import { Fragment, useEffect, useRef, useState } from 'react'
import parse from 'html-react-parser'
import {
  SurveyEngine_Models_StartGridQuestion,
  SurveyEngine_Models_StartGridAnswer,
  SurveyEngine_Models_StartGridResponse,
  SurveyEngine_Models_BaseResponse,
  SurveyEngine_Models_RankingResponse,
} from '../../../api'
import { GridLayout, GridLayoutItem } from '@progress/kendo-react-layout'
import { useGlobalCtx } from '../../../Context/GlobalContext'
import { Label, Error } from '@progress/kendo-react-labels'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons'

interface RankingProps {
  id: number
  message: string
  questions: SurveyEngine_Models_StartGridQuestion[]
  answers: SurveyEngine_Models_StartGridAnswer[]
  defaultAnswer: SurveyEngine_Models_StartGridResponse[]
  isError: boolean
  focus: boolean
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}
interface RankingAnswerItem {
  commandIndex: number
  answerValue: number
}

export const Ranking = (props: RankingProps) => {
  const [answers, setAnswers] = useState<
    Array<SurveyEngine_Models_StartGridResponse>
  >(props.defaultAnswer)
  const [isError, setIsError] = useState<boolean>(props.isError)
  const globalCTX = useGlobalCtx()
  let answerData = props.answers.map((answer) => {
    return {
      label: getText(answer.text ?? ''),
      value: answer.answerValue,
    }
  })
  const focusQuestion = useRef<SurveyEngine_Models_StartGridQuestion>({})
  const focusDropDownList = useRef<DropDownList>(null)

  if (props.isError) {
    for (let i = 0; i < props.questions.length; i++) {
      if (
        !props.defaultAnswer.find(
          (a) => a.commandIndex === props.questions[i].commandIndex
        )
      ) {
        focusQuestion.current = props.questions[i]
        break
      }
    }
  } else {
    focusQuestion.current = props.questions[0]
  }
  useEffect(() => {
    if (props.focus) focusDropDownList.current?.focus()

    if (props.defaultAnswer.length <= 0 || props.defaultAnswer === undefined) {
      props.defaultAnswer.push({
        commandIndex: 0,
        answerValue: -999,
        commandType: 'StartGridResponse',
      })
    } else if (props.defaultAnswer.length > 0) {
      let res: SurveyEngine_Models_RankingResponse = {
        commandIndex: props.id,
        commandType: 'Ranking',
        answers: props.defaultAnswer,
      }
      props.callback(res)
    }
    setIsError(props.isError)
    setAnswers([...props.defaultAnswer])
  }, [props])

  const handleDropDownBlur = (selection: RankingAnswerItem) => {
    //console.log(`OnBlur:${JSON.stringify(selection)}`);
    let draft: Array<SurveyEngine_Models_StartGridResponse> = [...answers]
    const exitingQue = draft.find(
      (res) => res.commandIndex === selection.commandIndex
    )
    const exitingAnsIndex = draft.findIndex(
      (res) =>
        res.answerValue === selection.answerValue &&
        res.commandIndex !== selection.commandIndex
    )
    if (exitingAnsIndex !== -1) {
      draft.splice(exitingAnsIndex, 1)

      setIsError(true)
    }

    if (exitingQue) exitingQue.answerValue = selection.answerValue
    else {
      draft.push({
        commandIndex: selection.commandIndex,
        answerValue: selection.answerValue,
        commandType: 'StartGridResponse',
      })
    }
    let filtered: Array<SurveyEngine_Models_StartGridResponse> = draft.filter(
      function (item) {
        return item.answerValue !== -999
      }
    )
    let res: SurveyEngine_Models_RankingResponse = {
      commandIndex: props.id,
      commandType: 'Ranking',
      answers: filtered,
    }
    props.callback(res)
    setAnswers(filtered)
    if (filtered.length === props.questions.length) {
      setIsError(false)
    }
  }
  const handleDropDownClose = (selection: RankingAnswerItem) => {
    //console.log(`OnClose:${JSON.stringify(selection)}`);
    let draft: Array<SurveyEngine_Models_StartGridResponse> = [...answers]
    const exitingQue = draft.find(
      (res) => res.commandIndex === selection.commandIndex
    )
    const exitingAnsIndex = draft.findIndex(
      (res) =>
        res.answerValue === selection.answerValue &&
        res.commandIndex !== selection.commandIndex
    )
    if (exitingAnsIndex !== -1) {
      draft.splice(exitingAnsIndex, 1)
      setIsError(true)
    }

    if (exitingQue) exitingQue.answerValue = selection.answerValue
    else {
      draft.push({
        commandIndex: selection.commandIndex,
        answerValue: selection.answerValue,
        commandType: 'StartGridResponse',
      })
    }

    let filtered: Array<SurveyEngine_Models_StartGridResponse> = draft.filter(
      function (item) {
        return item.answerValue !== -999
      }
    )

    let res: SurveyEngine_Models_RankingResponse = {
      commandIndex: props.id,
      commandType: 'Ranking',
      answers: filtered,
    }
    props.callback(res)
    setAnswers(filtered)
    if (filtered.length === props.questions.length) {
      setIsError(false)
    }
  }
  const handleDropDownChange = (selection: RankingAnswerItem) => {
    //console.log(`OnChange:${JSON.stringify(selection)}`);
    let draft: Array<SurveyEngine_Models_StartGridResponse> = [...answers]

    if (selection.answerValue === -999) {
      const ansIndex = draft.findIndex(
        (res) => res.commandIndex === selection.commandIndex
      )
      if (ansIndex !== -1) draft.splice(ansIndex, 1)
      setIsError(true)
    } else {
      const ans = draft.find(
        (res) => res.commandIndex === selection.commandIndex
      )
      if (ans) {
        ans.answerValue = selection.answerValue
      } else {
        draft.push({
          commandIndex: selection.commandIndex,
          answerValue: selection.answerValue,
          commandType: 'StartGridResponse',
        })
      }
    }

    /*     let res: SurveyEngine_Models_RankingResponse = {
          commandIndex: props.id,
          commandType: "Ranking",
          answers: draft
        }
        props.callback(res) */
    let filtered: Array<SurveyEngine_Models_StartGridResponse> = draft.filter(
      function (item) {
        return item.answerValue !== -999
      }
    )
    setAnswers(filtered)
    if (filtered.length === props.questions.length) {
      setIsError(false)
    }
  }
  function getText(html: string) {
    var divContainer = document.createElement('div')
    divContainer.innerHTML = html
    return divContainer.textContent || divContainer.innerText || ''
  }
  return (
    <>
      <Label
        className="theme-question text-xl font-semibold w-full block"
        id={`msglabel_${props.id.toString()}`}
      >
        {parse(props.message?.replace(/""/g, '"') ?? '')}
      </Label>
      <GridLayout
        className="pt-5"
        align={{ horizontal: 'stretch', vertical: 'stretch' }}
        gap={{
          rows: 10,
          cols: 10,
        }}
      >
        {props.questions.map((question, qindex) => {
          return (
            <Fragment key={`q_${qindex + 2}`}>
              <GridLayoutItem row={qindex + 2} col={1}>
                <Label className="text-xl font-semibold" id={`q_${qindex + 2}`}>
                  <span
                    className={
                      isError &&
                      !answers.find(
                        (e) => e.commandIndex === question.commandIndex
                      )
                        ? 'theme-validator-error-text text-base font-semibold '
                        : 'text-base font-semibold'
                    }
                  >
                    {parse(question.message?.replace(/""/g, '"') ?? '')}
                  </span>
                </Label>
              </GridLayoutItem>
              <GridLayoutItem row={qindex + 2} col={2}>
                <DropDownList
                  ref={
                    question.commandIndex === focusQuestion.current.commandIndex
                      ? focusDropDownList
                      : undefined
                  }
                  ariaLabelledBy={`msglabel_${props.id.toString()} q_${
                    qindex + 2
                  }`}
                  data={answerData}
                  textField="label"
                  dataItemKey="value"
                  value={
                    answerData.find(
                      (ad) =>
                        ad.value ===
                        answers.find(
                          (a) => a.commandIndex === question.commandIndex
                        )?.answerValue
                    ) ?? {
                      label: globalCTX.LangResources.rankingMsg.placeholder,
                      value: -999,
                    }
                  }
                  defaultItem={{
                    label: globalCTX.LangResources.rankingMsg.placeholder,
                    value: -999,
                  }}
                  onChange={(e: any) =>
                    handleDropDownChange({
                      commandIndex: question.commandIndex!,
                      answerValue: e.value.value,
                    })
                  }
                  onBlur={(e: any) =>
                    handleDropDownBlur({
                      commandIndex: question.commandIndex!,
                      answerValue: e.value.value,
                    })
                  }
                  onClose={(e: any) =>
                    handleDropDownClose({
                      commandIndex: question.commandIndex!,
                      answerValue: e.value.value,
                    })
                  }
                  className="input"
                />
              </GridLayoutItem>
            </Fragment>
          )
        })}
        <GridLayoutItem row={props.questions.length + 2} col={1} colSpan={2}>
          {isError && (
            <Error
              id={`error_ranking${props.id}`}
              className="theme-validator-error-text font-semibold"
              direction="start"
            >
              <FontAwesomeIcon
                icon={faCircleExclamation}
                className="theme-icon-spacer"
              />
              {globalCTX.LangResources.rankingMsg.noResponseErrorMsg}
            </Error>
          )}
        </GridLayoutItem>
      </GridLayout>
    </>
  )
}
